import React from 'react';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import Modal from './Modal';
import { performSignOut } from '../security/signOut';

interface InvalidSessionModalProps {
  isOpen: boolean;
}

const InvalidSessionModal: React.FC<InvalidSessionModalProps> = ({ isOpen }) => {

  const getLogoutPage = async () => {
    await performSignOut();
  };

  return (
    <Modal
      isOpen={isOpen}
        onClose={getLogoutPage}
        title="Your Session is Invalid"
        ariaLabelledBy="invalid-session-dialog-title"
        ariaDescribedBy="invalid-session-dialog-description"
        maxWidth="sm"
        showCloseButton={false}
        actions={
          <Button onClick={getLogoutPage} variant="contained" color="primary">
            Proceed to login
          </Button>
        }
      >
        <DialogContentText id="invalid-session-dialog-description">
          Please login again to continue.
        </DialogContentText>
      </Modal>
  );
};

export default InvalidSessionModal;
